import {
  Button,
  Flex,
  FormControl,
  FormLabel,
  HStack,
  Input,
  Select,
  SimpleGrid,
  Table,
  Tbody,
  Td,
  Text,
  Textarea,
  Th,
  Thead,
  Tr,
  useColorModeValue
} from "@chakra-ui/react";
import { GroupBase, Select as AutoComplete } from "chakra-react-select";
import { ContatoType } from "models/contato_type";
import { Project } from "models/project_type";
import { OptionType } from "models/select_mode";
import { UsuarioModel } from "models/user_model";
import { MdEdit, MdFileCopy, MdMessage, MdNoteAdd, MdNotifications } from "react-icons/md";
import InputMask from "react-input-mask";

interface IHomeComponent {
  accountSelected: Project;
  users: UsuarioModel[];
  contatoAgencia: ContatoType;
  contatoCliente: ContatoType;
}

const HomeComponent = ({
  accountSelected,
  users,
  contatoAgencia,
  contatoCliente,
}: IHomeComponent) => {
  const textColor = useColorModeValue("secondaryGray.900", "white");
  const borderColor = useColorModeValue("gray.200", "whiteAlpha.100");
  const mask = "(99) 99999-9999";

  console.log(accountSelected, 'accountSelected')
  return (
    <>
      <Text mt={8} fontSize={18} color={"#422AFB"} fontWeight={"bold"} mb={4}>
        Ações
      </Text>

      <HStack justifyContent={"flex-start"}>
        <Button
          leftIcon={<MdEdit />}
          colorScheme="brand"
          size={"sm"}
          variant="solid"
        >
          Editar
        </Button>
        <Button
          leftIcon={<MdNoteAdd />}
          colorScheme="brand"
          size={"sm"}
          variant="solid"
        >
          Tarefas
        </Button>
        <Button
          leftIcon={<MdFileCopy />}
          colorScheme="brand"
          size={"sm"}
          variant="solid"
        >
          Arquivos
        </Button>
        <Button
          leftIcon={<MdMessage />}
          colorScheme="brand"
          size={"sm"}
          variant="solid"
        >
          Mensagens
        </Button>
        <Button
          leftIcon={<MdNotifications />}
          colorScheme="brand"
          size={"sm"}
          variant="solid"
        >
          Notificações
        </Button>
      </HStack>

      <SimpleGrid column={1} spacing={4} mt={24}>
        <FormControl>
          <FormLabel
            display="flex"
            ms="4px"
            fontSize="sm"
            fontWeight="bold"
            mt={4}
            color={"black"}
          >
            Contexto do Projeto
          </FormLabel>
          <Textarea
            defaultValue={accountSelected.descricao}
            fontSize="sm"
            height={100}
            ms={{ base: "0px", md: "0px" }}
            placeholder="Preencha o contexto do projeto"
            fontWeight="500"
            size="md"
          />
        </FormControl>
      </SimpleGrid>

      <Text mt={8} fontSize={18} color={"#422AFB"} fontWeight={"bold"} mb={4}>
        Dados do projeto
      </Text>

      <SimpleGrid columns={3} spacing={4} mt={4}>
        <FormControl>
          <FormLabel
            display="flex"
            ms="4px"
            fontSize="sm"
            fontWeight="500"
            color={"black"}
            mb="8px"
          >
            Produtor(a) Broders Responsável
          </FormLabel>

          <AutoComplete<OptionType, false, GroupBase<OptionType>>
            size="md"
            placeholder="Busque o Responsável"
            isRequired={true}
            name={"executivo"}
            options={users?.map((item) => {
              return {
                label: item.nome,
                value: item.id,
              };
            })}
            defaultValue={{
              label: users[0]?.nome,
              value: users[0]?.id,
            }}
          />
        </FormControl>

        <FormControl>
          <FormLabel
            display="flex"
            ms="4px"
            fontSize="sm"
            fontWeight="500"
            color={"black"}
            mb="8px"
          >
            E-mail Produtor(a) Broders
          </FormLabel>

          <Input
            isRequired={true}
            fontSize="sm"
            ms={{ base: "0px", md: "0px" }}
            type="text"
            placeholder=" E-mail Produtor(a) Broders"
            fontWeight="500"
            size="md"
            disabled={false}
            value={users[0]?.email}
          />
        </FormControl>

        <FormControl>
          <FormLabel
            display="flex"
            ms="4px"
            fontSize="sm"
            fontWeight="500"
            color={"black"}
            mb="8px"
          >
            Telefone Produtor(a) Broders
          </FormLabel>

          <Input
            isRequired={true}
            fontSize="sm"
            ms={{ base: "0px", md: "0px" }}
            type="text"
            placeholder="Telefone Produtor(a) Broders"
            fontWeight="500"
            size="md"
            disabled={false}
            as={InputMask}
            mask={mask}
            value={users[0]?.telefone}
          />
        </FormControl>
      </SimpleGrid>
      <SimpleGrid columns={3} spacing={4} mt={4}>
        <FormControl>
          <FormLabel
            display="flex"
            ms="4px"
            fontSize="sm"
            fontWeight="500"
            color={"black"}
            mb="8px"
          >
            Executivo(a) Broders Responsável
          </FormLabel>

          <AutoComplete<OptionType, false, GroupBase<OptionType>>
            size="md"
            placeholder="Busque o Responsável"
            isRequired={true}
            name={"executivo"}
            options={users?.map((item) => {
              return {
                label: item.nome,
                value: item.id,
              };
            })}
            defaultValue={{
              label: users[1]?.nome,
              value: users[1]?.id,
            }}
          />
        </FormControl>

        <FormControl>
          <FormLabel
            display="flex"
            ms="4px"
            fontSize="sm"
            fontWeight="500"
            color={"black"}
            mb="8px"
          >
            E-mail Executivo(a) Broders
          </FormLabel>

          <Input
            isRequired={true}
            fontSize="sm"
            ms={{ base: "0px", md: "0px" }}
            type="text"
            placeholder="E-mail Executivo(a) Broders"
            fontWeight="500"
            size="md"
            disabled={false}
            value={users[1]?.email}
          />
        </FormControl>

        <FormControl>
          <FormLabel
            display="flex"
            ms="4px"
            fontSize="sm"
            fontWeight="500"
            color={"black"}
            mb="8px"
          >
            Telefone Executivo(a) Broders
          </FormLabel>

          <Input
            isRequired={true}
            fontSize="sm"
            ms={{ base: "0px", md: "0px" }}
            type="text"
            placeholder="Telefone Executivo(a) Broders"
            fontWeight="500"
            size="md"
            disabled={false}
            as={InputMask}
            mask={mask}
            value={users[1]?.telefone}
          />
        </FormControl>
      </SimpleGrid>
      <SimpleGrid columns={3} spacing={4} mt={4}>
        <FormControl>
          <FormLabel
            display="flex"
            ms="4px"
            fontSize="sm"
            fontWeight="500"
            color={"black"}
            mb="8px"
          >
            Diretor(a) de Produção
          </FormLabel>

          <AutoComplete<OptionType, false, GroupBase<OptionType>>
            size="md"
            placeholder="Busque o Responsável"
            isRequired={true}
            name={"executivo"}
            options={users?.map((item) => {
              return {
                label: item.nome,
                value: item.id,
              };
            })}
            defaultValue={{
              label: users[2]?.nome,
              value: users[2]?.id,
            }}
          />
        </FormControl>

        <FormControl>
          <FormLabel
            display="flex"
            ms="4px"
            fontSize="sm"
            fontWeight="500"
            color={"black"}
            mb="8px"
          >
            E-mail Diretor(a) de Produção
          </FormLabel>

          <Input
            isRequired={true}
            fontSize="sm"
            ms={{ base: "0px", md: "0px" }}
            type="text"
            placeholder="E-mail Diretor(a) de Produção"
            fontWeight="500"
            size="md"
            disabled={false}
            value={users[2]?.email}
          />
        </FormControl>

        <FormControl>
          <FormLabel
            display="flex"
            ms="4px"
            fontSize="sm"
            fontWeight="500"
            color={"black"}
            mb="8px"
          >
            Telefone Diretor(a) de Produção
          </FormLabel>

          <Input
            isRequired={true}
            fontSize="sm"
            ms={{ base: "0px", md: "0px" }}
            type="text"
            placeholder="Telefone Diretor(a) de Produção"
            as={InputMask}
            mask={mask}
            fontWeight="500"
            size="md"
            disabled={false}
            value={users[2]?.telefone}
          />
        </FormControl>
      </SimpleGrid>
      <SimpleGrid columns={3} spacing={4} mt={4}>
        <FormControl>
          <FormLabel
            display="flex"
            ms="4px"
            fontSize="sm"
            fontWeight="500"
            color={"black"}
            mb="8px"
          >
            Diretor(a) de Cena
          </FormLabel>

          <AutoComplete<OptionType, false, GroupBase<OptionType>>
            size="md"
            placeholder="Busque o Responsável"
            isRequired={true}
            name={"executivo"}
            options={users?.map((item) => {
              return {
                label: item.nome,
                value: item.id,
              };
            })}
            defaultValue={{
              label: users[3]?.nome,
              value: users[3]?.id,
            }}
          />
        </FormControl>

        <FormControl>
          <FormLabel
            display="flex"
            ms="4px"
            fontSize="sm"
            fontWeight="500"
            color={"black"}
            mb="8px"
          >
            E-mail Diretor(a) de Cena
          </FormLabel>

          <Input
            isRequired={true}
            fontSize="sm"
            ms={{ base: "0px", md: "0px" }}
            type="text"
            placeholder="E-mail Diretor(a) de Cena"
            fontWeight="500"
            size="md"
            disabled={false}
            value={users[3]?.email}
          />
        </FormControl>

        <FormControl>
          <FormLabel
            display="flex"
            ms="4px"
            fontSize="sm"
            fontWeight="500"
            color={"black"}
            mb="8px"
          >
            Telefone Diretor(a) de Cena
          </FormLabel>

          <Input
            isRequired={true}
            fontSize="sm"
            ms={{ base: "0px", md: "0px" }}
            type="text"
            placeholder="Telefone Diretor(a) de Cena"
            fontWeight="500"
            size="md"
            disabled={false}
            value={users[3]?.telefone}
            as={InputMask}
            mask={mask}
          />
        </FormControl>
      </SimpleGrid>

      <Text mt={8} fontSize={18} color={"#422AFB"} fontWeight={"bold"} mb={4}>
        Locais de Produção
      </Text>

      <Table variant="striped" color="gray.500" mb="24px" mt="12px">
        <Thead>
          <Tr>
            <Th pe="10px" borderColor={borderColor} cursor="pointer">
              <Flex
                justifyContent="space-between"
                align="center"
                fontSize={{ sm: "10px", lg: "12px" }}
                color="gray.400"
              >
                #CIDADE
              </Flex>
            </Th>
            <Th pe="10px" borderColor={borderColor} cursor="pointer">
              <Flex
                justifyContent="space-between"
                align="center"
                fontSize={{ sm: "10px", lg: "12px" }}
                color="gray.400"
              >
                #ESTADO
              </Flex>
            </Th>
            <Th pe="10px" borderColor={borderColor} cursor="pointer">
              <Flex
                justifyContent="space-between"
                align="center"
                fontSize={{ sm: "10px", lg: "12px" }}
                color="gray.400"
              >
                #DIÁRIAS
              </Flex>
            </Th>
          </Tr>
        </Thead>

        <Tbody>
          {accountSelected?.ProjetoCiddade?.map((item, idx) => {
            return (
              <Tr key={`${item.id}-${item}-${idx}`}>
                <Td
                  fontSize={{ sm: "14px" }}
                  borderColor="transparent"
                  color={"black"}
                >
                  <Input
                    isRequired={false}
                    fontSize="sm"
                    defaultValue={item.cidade}
                    ms={{ base: "0px", md: "0px" }}
                    type="text"
                    placeholder="qtd"
                    fontWeight="500"
                    border={"none"}
                    name={`cidade-${item.id}`}
                    size="md"
                  />
                </Td>
                <Td fontSize={{ sm: "14px" }} borderColor="transparent">
                  <Input
                    isRequired={false}
                    fontSize="sm"
                    defaultValue={item.estado}
                    ms={{ base: "0px", md: "0px" }}
                    type="text"
                    placeholder="estado"
                    fontWeight="500"
                    border={"none"}
                    name={`estado-${item.id}`}
                    size="md"
                  />
                </Td>
                <Td fontSize={{ sm: "14px" }} borderColor="transparent">
                  <Input
                    isRequired={false}
                    fontSize="sm"
                    defaultValue={item.diarias}
                    ms={{ base: "0px", md: "0px" }}
                    type="text"
                    placeholder="diarias"
                    fontWeight="500"
                    border={"none"}
                    name={`diarias-${item.id}`}
                    size="md"
                  />
                </Td>
              </Tr>
            );
          })}
        </Tbody>
      </Table>

      <Text mt={8} fontSize={18} color={"#422AFB"} fontWeight={"bold"} mb={4}>
        Recursos
      </Text>

      <SimpleGrid columns={4} spacing={4} mt={4}>
        <FormControl>
          <FormLabel
            display="flex"
            ms="4px"
            fontSize="sm"
            fontWeight="500"
            color={"black"}
            mb="8px"
          >
            Link / Anexo do Tratamento do Diretor(a)
          </FormLabel>

          <Input
            isRequired={true}
            fontSize="sm"
            ms={{ base: "0px", md: "0px" }}
            type="text"
            defaultValue={accountSelected?.linkDiretor}
            placeholder="Link / Anexo do Tratamento do Diretor(a)"
            fontWeight="500"
            size="md"
            disabled={false}
          />
        </FormControl>

        <FormControl>
          <FormLabel
            display="flex"
            ms="4px"
            fontSize="sm"
            fontWeight="500"
            color={"black"}
            mb="8px"
          >
            Link pasta Executiva no Drive
          </FormLabel>

          <Input
            isRequired={true}
            fontSize="sm"
            ms={{ base: "0px", md: "0px" }}
            type="text"
            placeholder="Link pasta Executiva no Drive"
            fontWeight="500"
            value={accountSelected?.linkPastaExecutiva}
            size="md"
            disabled={false}
          />
        </FormControl>

        <FormControl>
          <FormLabel
            display="flex"
            ms="4px"
            fontSize="sm"
            fontWeight="500"
            color={"black"}
            mb="8px"
          >
            Link pasta Finalização no Drive
          </FormLabel>

          <Input
            isRequired={true}
            fontSize="sm"
            ms={{ base: "0px", md: "0px" }}
            type="text"
            placeholder="Link pasta Finalização no Drive"
            fontWeight="500"
            size="md"
            defaultValue={accountSelected?.linkPastaFinalizacao}
            disabled={false}
          />
        </FormControl>

        <FormControl>
          <FormLabel
            display="flex"
            ms="4px"
            fontSize="sm"
            fontWeight="500"
            color={"black"}
            mb="8px"
          >
            Link / Anexo do Resumo do Cronograma
          </FormLabel>

          <Input
            isRequired={true}
            fontSize="sm"
            ms={{ base: "0px", md: "0px" }}
            type="text"
            placeholder="Link / Anexo do Resumo do Cronograma"
            fontWeight="500"
            size="md"
            defaultValue={accountSelected?.linkCronograma}
            disabled={false}
          />
        </FormControl>
      </SimpleGrid>

      <SimpleGrid column={1} spacing={4}>
        <FormControl>
          <FormLabel
            display="flex"
            ms="4px"
            fontSize="sm"
            fontWeight="500"
            mt={4}
            color={"black"}
          >
            Resumo Cronograma
          </FormLabel>
          <Textarea
            fontSize="sm"
            height={100}
            ms={{ base: "0px", md: "0px" }}
            placeholder="
            PPM Agência:  dd/mm
            PPM Cliente: dd/mm
            Diárias: dd/mm
            Entrega: dd/mm"
            defaultValue={accountSelected?.resumoCronograma}
            fontWeight="500"
            size="md"
          />
        </FormControl>
      </SimpleGrid>

      <SimpleGrid column={1} spacing={4}>
        <FormControl>
          <FormLabel
            display="flex"
            ms="4px"
            fontSize="sm"
            fontWeight="500"
            mt={4}
            color={"black"}
          >
            Notas Internas
          </FormLabel>
          <Textarea
            fontSize="sm"
            height={100}
            ms={{ base: "0px", md: "0px" }}
            placeholder="Notas Internas"
            defaultValue={accountSelected.notasInternas}
            fontWeight="500"
            size="md"
          />
        </FormControl>
      </SimpleGrid>

      <Text mt={8} fontSize={18} color={"#422AFB"} fontWeight={"bold"} mb={4}>
        Dados Cliente/Agência
      </Text>

      {accountSelected?.Orcamento?.showAgencia && (
        <SimpleGrid columns={5} spacing={2} mt={4}>
          <FormControl>
            <FormLabel
              display="flex"
              ms="4px"
              fontSize="sm"
              fontWeight="bold"
              color={textColor}
              mb="8px"
            >
              Agência
            </FormLabel>

            <AutoComplete<OptionType, false, GroupBase<OptionType>>
              size="md"
              onChange={(e) => {}}
              placeholder="Busque a Agência"
              name={"agencia"}
              value={{
                label: accountSelected?.Orcamento?.agencia?.nome,
                value: accountSelected?.Orcamento?.agencia?.id,
              }}
            />
          </FormControl>

          <FormControl>
            <FormLabel
              display="flex"
              ms="4px"
              fontSize="sm"
              fontWeight="bold"
              color={textColor}
              mb="8px"
            >
              Nome do Contato da Agência
            </FormLabel>
            <Select value={contatoAgencia?.id} size="md" onChange={(e) => {}}>
              <option value={contatoAgencia?.id}>{contatoAgencia?.nome}</option>
            </Select>
          </FormControl>

          <FormControl>
            <FormLabel
              display="flex"
              ms="4px"
              fontSize="sm"
              fontWeight="bold"
              color={textColor}
              mb="8px"
            >
              Email do Contato da Agência
            </FormLabel>

            <Input
              fontSize="sm"
              ms={{ base: "0px", md: "0px" }}
              type="text"
              placeholder="Email do Contato da Agência"
              fontWeight="bold"
              size="md"
              disabled={false}
              value={accountSelected?.Orcamento?.contatoAgenciaEmail}
            />
          </FormControl>

          <FormControl>
            <FormLabel
              display="flex"
              ms="4px"
              fontSize="sm"
              fontWeight="bold"
              color={textColor}
              mb="8px"
            >
              Telefone do Contato da Agência
            </FormLabel>

            <Input
              fontSize="sm"
              ms={{ base: "0px", md: "0px" }}
              type="text"
              placeholder=" Telefone do Contato da Agência"
              fontWeight="bold"
              size="md"
              disabled={false}
              value={accountSelected?.Orcamento?.contatoAgenciaTelefone}
            />
          </FormControl>

          <FormControl>
            <FormLabel
              display="flex"
              ms="4px"
              fontSize="sm"
              fontWeight="bold"
              color={textColor}
              mb="8px"
            >
              Cargo do Responsável da Agência
            </FormLabel>

            <Input
              fontSize="sm"
              ms={{ base: "0px", md: "0px" }}
              type="text"
              placeholder="Cargo do Responsável da Agência"
              fontWeight="bold"
              size="md"
              onChange={(e) => {}}
              // value={contatoAgencia1?.cargo}
            />
          </FormControl>
        </SimpleGrid>
      )}

      <SimpleGrid columns={5} spacing={2} mt={4}>
        <FormControl>
          <FormLabel
            display="flex"
            ms="4px"
            fontSize="sm"
            fontWeight="bold"
            color={textColor}
            mb="8px"
          >
            Cliente
          </FormLabel>

          <AutoComplete<OptionType, false, GroupBase<OptionType>>
            size="md"
            placeholder="Busque o Cliente"
            isRequired={true}
            name={"cliente"}
            defaultValue={{
              label: accountSelected?.Orcamento?.cliente?.nome,
              value: accountSelected?.Orcamento?.cliente?.id,
            }}
          />
        </FormControl>

        <FormControl>
          <FormLabel
            display="flex"
            ms="4px"
            fontSize="sm"
            fontWeight="bold"
            color={textColor}
            mb="8px"
          >
            Responsável Aprovação Cliente
          </FormLabel>
          <Select value={contatoCliente?.id} size="md">
            <option value={contatoCliente?.id}>{contatoCliente?.nome}</option>
          </Select>
        </FormControl>

        <FormControl>
          <FormLabel
            display="flex"
            ms="4px"
            fontSize="sm"
            fontWeight="bold"
            color={textColor}
            mb="8px"
          >
            Email do Contato do Cliente
          </FormLabel>

          <Input
            fontSize="sm"
            ms={{ base: "0px", md: "0px" }}
            type="text"
            placeholder=" Email do Contato do Cliente"
            fontWeight="bold"
            size="md"
            disabled={false}
            value={accountSelected?.Orcamento?.contatoClienteEmail}
          />
        </FormControl>

        <FormControl>
          <FormLabel
            display="flex"
            ms="4px"
            fontSize="sm"
            fontWeight="bold"
            color={textColor}
            mb="8px"
          >
            Telefone do Contato do Cliente
          </FormLabel>

          <Input
            fontSize="sm"
            ms={{ base: "0px", md: "0px" }}
            type="text"
            placeholder=" Telefone de Contato do Cliente"
            fontWeight="bold"
            size="md"
            onChange={(e) => {}}
            value={accountSelected?.Orcamento?.contatoClienteTelefone}
          />
        </FormControl>

        <FormControl>
          <FormLabel
            display="flex"
            ms="4px"
            fontSize="sm"
            fontWeight="bold"
            color={textColor}
            mb="8px"
          >
            Cargo do Responsável do Cliente
          </FormLabel>

          <Input
            fontSize="sm"
            ms={{ base: "0px", md: "0px" }}
            type="text"
            placeholder="Cargo do Responsável do Cliente"
            fontWeight="bold"
            size="md"
            onChange={(e) => {}}
            value={contatoCliente?.cargo}
          />
        </FormControl>
      </SimpleGrid>

      <Text mt={8} fontSize={18} color={"#422AFB"} fontWeight={"bold"} mb={4}>
        Contatos Adicionais
      </Text>

      <Table variant="striped" color="gray.500" mb="24px" mt="12px">
        <Thead>
          <Tr>
            <Th pe="10px" borderColor={borderColor} cursor="pointer">
              <Flex
                justifyContent="space-between"
                align="center"
                fontSize={{ sm: "10px", lg: "12px" }}
                color="gray.400"
              >
                #NOME
              </Flex>
            </Th>

            <Th pe="10px" borderColor={borderColor} cursor="pointer">
              <Flex
                justifyContent="space-between"
                align="center"
                fontSize={{ sm: "10px", lg: "12px" }}
                color="gray.400"
              >
                #CARGO
              </Flex>
            </Th>

            <Th pe="10px" borderColor={borderColor} cursor="pointer">
              <Flex
                justifyContent="space-between"
                align="center"
                fontSize={{ sm: "10px", lg: "12px" }}
                color="gray.400"
              >
                #EMAIL
              </Flex>
            </Th>

            <Th pe="10px" borderColor={borderColor} cursor="pointer">
              <Flex
                justifyContent="space-between"
                align="center"
                fontSize={{ sm: "10px", lg: "12px" }}
                color="gray.400"
              >
                #TELEFONE
              </Flex>
            </Th>
          </Tr>
        </Thead>
        <Tbody>
          {accountSelected.ProjetoContato?.filter(
            (a) => a.tipo === "cliente"
          ).map((item, index) => {
            return (
              <Tr key={`${item.id}-${item}-${index}`}>
                <Td fontSize={{ sm: "14px" }} borderColor="transparent">
                  <Input
                    defaultValue={item.nome}
                    isRequired={false}
                    fontSize="sm"
                    ms={{ base: "0px", md: "0px" }}
                    type="text"
                    placeholder="Preencha a Nome do Contato"
                    fontWeight="500"
                    size="md"
                  />
                </Td>
                <Td fontSize={{ sm: "14px" }} borderColor="transparent">
                  <Input
                    defaultValue={item.cargo}
                    isRequired={false}
                    fontSize="sm"
                    ms={{ base: "0px", md: "0px" }}
                    type="text"
                    placeholder="Preencha o Cargo do Contato"
                    fontWeight="500"
                    size="md"
                  />
                </Td>

                <Td fontSize={{ sm: "14px" }} borderColor="transparent">
                  <Input
                    defaultValue={item.email}
                    isRequired={false}
                    fontSize="sm"
                    ms={{ base: "0px", md: "0px" }}
                    type="text"
                    placeholder="Preencha o Email do Contato"
                    fontWeight="500"
                    size="md"
                  />
                </Td>

                <Td fontSize={{ sm: "14px" }} borderColor="transparent">
                  <Input
                    defaultValue={item.telefone}
                    isRequired={false}
                    fontSize="sm"
                    ms={{ base: "0px", md: "0px" }}
                    type="text"
                    placeholder="Preencha o Telefone do Contato"
                    fontWeight="500"
                    size="md"
                  />
                </Td>
              </Tr>
            );
          })}
        </Tbody>
      </Table>

      <SimpleGrid column={1} spacing={4} mb={16}>
        <FormControl>
          <FormLabel
            display="flex"
            ms="4px"
            fontSize="sm"
            fontWeight="bold"
            mt={4}
            color={"black"}
          >
            Notas sobre Agência/Cliente
          </FormLabel>
          <Textarea
            fontSize="sm"
            height={100}
            ms={{ base: "0px", md: "0px" }}
            placeholder="Preencha as Notas sobre Agência/Cliente"
            defaultValue={accountSelected.notasClienteAgencia}
            fontWeight="500"
            size="md"
          />
        </FormControl>
      </SimpleGrid>
    </>
  );
};
export default HomeComponent;
